// extracted by mini-css-extract-plugin
export var parcelRow = "_ur-0";